// extracted by mini-css-extract-plugin
export var blue = "_l-f";
export var brand = "_l-b";
export var darkGrey = "_l-e";
export var disabled = "_l-4";
export var disabledSubtle = "_l-5";
export var error = "_l-6";
export var green = "_l-g";
export var grey = "_l-d";
export var icon = "_l-0";
export var inherit = "_l-a";
export var lightGrey = "_l-c";
export var orange = "_l-i";
export var pink = "_l-k";
export var primary = "_l-1";
export var purple = "_l-l";
export var red = "_l-j";
export var secondary = "_l-2";
export var success = "_l-9";
export var tertiary = "_l-3";
export var warning = "_l-7";
export var warningSecondary = "_l-8";
export var white = "_l-m";
export var yellow = "_l-h";